export default __webpack_public_path__ + "static/media/gp-red-arrow.8edfa3ce.svg";